module.exports = __webpack_public_path__ + "img/1538282221.cdec810a.jpg";